import {
  ref,
  reactive,
  onBeforeMount,
  getCurrentInstance,
} from "@vue/composition-api";
import store from "@/store";
import { privilegeCodeTemplateModel } from "@/models/privilege/privilege-code-template";
import inventoryPrivilegeFormModel from '@/models/inventory/inventory-privilege-form'
import usePagination from "@/views/components/pagination/usePagination";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default function useExportCode(props) {
    const vm = getCurrentInstance().proxy;

    const { pagination, onPageChange, onFilterEntity } = usePagination();
    const {
      filters,
      ordering,
    } = useFilterHeaderTable();

    const {
      openDefaultErrorModal,
      openErrorModal,
      openSuccessModal,
      openWarningModal
    } = useValidationModal();

    const {
      getInventoryList,
      ExportCodeTemplate,
    } = privilegeCodeTemplateModel();
    
    const {
      fetchPrivilegeEntryDetail,
    } = inventoryPrivilegeFormModel();

    const loading = reactive({
      tableData: false,
    });

    const formStatus = reactive({
      inventoryId: null,
      inventoryLabel: null,
    });

    const formManageStock = reactive({
      beforeStockMode : 1,
      stockMode : 1,
      removalStrategy : 1
    })

    const removalOptions = ref([
      { label: "FIFO (First In, First Out)", value: 1 },
      { label: "FEFO (First Expired, First Out)", value: 2 },
      { label: "LIFO (Last In, First Out)", value: 3 },
    ])

    const formEntryDetail = reactive({
      entryId: "",
      name: "",
      reference: "",
      privilegeType: "",
      codeType: "",
      image: "",
      note: "",
      status: false,
      isImportAvailable : true
    });

    const formCodeDetail = reactive({
      template_id: 0,
      title: "",
      template_ref: "",
    });

    const qtyTotal = ref(0);

    const optionData = reactive({
      inventoryList: [],
    });

    const fetchInventoryOption = (showLoading = false) => {
      if (showLoading) {
        loading.tableData = true;
      }
      getInventoryList.payload.Page = pagination.currentPage;
      getInventoryList.payload.Limit = 10000;
      getInventoryList.payload.Filters = filters;
      getInventoryList.payload.Ordering = ordering.value;
      getInventoryList.payload.Privilege_Id = props.templateData.privilege_id;
      store
        .dispatch("api/apiRequest", getInventoryList)
        .then((response) => {
          optionData.inventoryList = response.data.payload.map((item) => ({
            ...item,
            label: item.name,
            value: item.inventory_id,
          }));
          pagination.rows = response.data.payload.length;
          pagination.totalRows = response.data.filtered_record;
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.tableData = false;
        });
    };

    const fetchInventoryEntryDetail = (showLoading = false,inventoryId) => {
      if (showLoading) {
        loading.tableData = true;
      }
      fetchPrivilegeEntryDetail.payload.Inventory_Id = inventoryId;
      fetchPrivilegeEntryDetail.payload.Privilege_Id = props.templateData.privilege_id;
      store
      .dispatch("api/apiRequest", fetchPrivilegeEntryDetail)
      .then((response) => {
        if (response.status == "success") {
          let resp = response.data.resp;
          formEntryDetail.entryId = resp.entry_id;
          formEntryDetail.name = resp.privilege.name_en;
          formEntryDetail.reference = resp.privilege.alt_reference;
          formEntryDetail.image = resp.privilege.image_url;
          formEntryDetail.privilegeType = resp.privilege.type_desc;
          formEntryDetail.codeType = resp.privilege.cpc_type_desc;
          formEntryDetail.status = resp.privilege.status;
          formEntryDetail.isImportAvailable = resp.is_import_available;
          qtyTotal.value = resp.remaining_qty;
          formManageStock.removalStrategy = resp.fullfillment_mode;
        }
      })
      .catch((error) => {openDefaultErrorModal(error);})
      .finally(() => {
        loading.tableData = false;
      });
    }

    const fetchExportCode = () => {
      loading.form = true;
      let payload = {
        Template_Id: props.templateData.template_id,
        Privilege_Id: props.templateData.privilege_id,
        Entry_Id: formEntryDetail.entryId,
        Export: quantityValue.Export,
        Removal_Stategy: formManageStock.removalStrategy,
        Note: null,
      };
      ExportCodeTemplate.payload = payload;
      store
      .dispatch("api/apiRequest", ExportCodeTemplate)
      .then((response) => {
        openSuccessModal(
          "ทำรายการสำเร็จ !",
          null,
          "ตกลง",
          () => fetchInventoryEntryDetail(true,formStatus.inventoryId)
        );
        vm.$emit("onNext");
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.form = false;
      });
    }


    const onSelectInventory = (inventoryId) => {
      formStatus.inventoryId = inventoryId;
      fetchInventoryEntryDetail(true,inventoryId);
    };


    const quantityValue = reactive({
      Export : 0
    })

    const updateExport = (number) => {
      quantityValue.Export = number
      if(quantityValue.Export > qtyTotal.value){
        openWarningModal(
          'Export Code',
          'จำนวนที่ต้องการ Export มากกว่า Balance ที่มีอยู่',
          null,
          null,
          null,
          'ปิด',
          false,
          true,
        );
      }
    }

    const onSubmitExportCode = () => {
      if(quantityValue.Export <= qtyTotal.value){
        openWarningModal(
          'Export Code',
          `ต้องการยืนยันใช่หรือไม่ ?`,
          () => {
            fetchExportCode();
          }
        )
      } else {
        openWarningModal(
          'Export Code',
          'จำนวนที่ต้องการ Export มากกว่า Balance ที่มีอยู่',
          null,
          null,
          null,
          'ปิด',
          false,
          true,
        );
      }
    }


  
    onBeforeMount(() => {
      formCodeDetail.template_id = props.templateData.template_id
      formCodeDetail.title = props.templateData.title
      formCodeDetail.template_ref = props.templateData.template_ref
      fetchInventoryOption(true)
    });

    return{
      loading,
      optionData,
      formStatus,
      formEntryDetail,
      formCodeDetail,
      qtyTotal,
      quantityValue,
      formManageStock,
      removalOptions,
      updateExport,
      onSelectInventory,
      onSubmitExportCode
    };
}